import { generator, compose, getSpacing } from './theme.js';
import { toPx } from './unit.js';

const flexDirection = (props) => generator({
    props,
    prop: ['flexDirection'],
    cssProperty: 'flexDirection',
});
const alignContent = (props) => generator({
    props,
    prop: ['alignContent'],
    cssProperty: 'alignContent',
});
const alignItems = (props) => generator({
    props,
    prop: ['alignItems'],
    cssProperty: 'alignItems',
});
const alignSelf = (props) => generator({
    props,
    prop: ['alignSelf'],
    cssProperty: 'alignSelf',
});
const justifyContent = (props) => generator({
    props,
    prop: ['justifyContent'],
    cssProperty: 'justifyContent',
});
const justifySelf = (props) => generator({
    props,
    prop: ['justifySelf'],
    cssProperty: 'justifySelf',
});
const flex = (props) => generator({
    props,
    prop: ['flex'],
    cssProperty: 'flex',
});
const flexBasis = (props) => generator({
    props,
    prop: ['flexBasis'],
    cssProperty: 'flexBasis',
});
const flexFlow = (props) => generator({
    props,
    prop: ['flexFlow'],
    cssProperty: 'flexFlow',
});
const flexGrow = (props) => generator({
    props,
    prop: ['flexGrow'],
    cssProperty: 'flexGrow',
});
const flexShrink = (props) => generator({
    props,
    prop: ['flexShrink'],
    cssProperty: 'flexShrink',
});
const flexWrap = (props) => generator({
    props,
    prop: ['flexWrap'],
    cssProperty: 'flexWrap',
});
const order = (props) => generator({
    props,
    prop: ['order'],
    cssProperty: 'order',
});
const gap = (props) => generator({
    props,
    prop: ['gap'],
    cssProperty: 'gap',
    getter: getSpacing,
    transform: toPx,
});
const flexes = compose(flex, flexBasis, flexFlow, flexGrow, flexShrink, flexWrap, flexDirection, alignItems, alignContent, alignSelf, justifyContent, justifySelf, order, gap);

export { alignContent, alignItems, alignSelf, flex, flexBasis, flexDirection, flexFlow, flexGrow, flexShrink, flexWrap, flexes, gap, justifyContent, justifySelf, order };
